import React from 'react';
import ChatBox from '../components/ChatBox';
import ChatInput from '../components/ChatInput';
import Sidebar from '../components/Sidebar';
import { useChat } from '../hooks/useChat';

const ChatPage: React.FC = () => {
  const {
    chats,
    activeChat,
    activeChatId,
    isLoading,
    error,
    createNewChat,
    selectChat,
    sendChat,
  } = useChat();

  return (
    <div className="min-h-[calc(100vh-200px)] bg-slate-900 text-slate-100">
      <div className="flex h-[calc(100vh-200px)] flex-col md:flex-row">
        <Sidebar
          chats={chats}
          activeChatId={activeChatId}
          onNewChat={createNewChat}
          onSelectChat={selectChat}
        />

        <section className="flex-1 flex flex-col bg-slate-900">
          <div className="border-b border-slate-800 px-4 py-3">
            <h1 className="text-lg font-semibold">Stock AI Chat</h1>
            <p className="text-xs text-slate-400">Free AI chat for stock-related questions.</p>
          </div>

          <ChatBox messages={activeChat?.messages || []} isLoading={isLoading} />

          {error && (
            <div className="px-4 pb-2 text-sm text-red-400">
              {error}
            </div>
          )}

          <ChatInput onSend={sendChat} isLoading={isLoading} />
        </section>
      </div>
    </div>
  );
};

export default ChatPage;
